define('viewmodels/app/analytics/__print',['knockout', 'lodash', 'jquery', 'moment',
        'pdfGear/generator/const', '../__print', 'atn/pdfUtils', 'atn/atn'
    ],
    function(ko, _, $, moment, PDF_CONST, printHandler,
        pdfUtils, atn) {
        'use strict';

        return {
            print: printAnalytics
        };

        /**
         * This function is used to generate pdftemplate for printHanlder
         * @param  {object} info chart object which contains chart information
         * @return {undefined}
         */
        function printAnalytics(info) {
            printHandler.completed(20);
            //filling the widgets section.
            // widgets = getAnalyticsWidgets(info);

            getAnalyticsWidgets(info).then(
                function(widgets) {
                    printHandler.completed(50);

                    return printHandler.printCharts(
                        info.name,
                        widgets,
                        atn.config.messages.pdf.reportName
                    )
                }
            ).then(
                function() {
                    printHandler.completed(100);
                }
            );
        }

        /**
         * this function gets the widgets available in analytics
         * @param  {object} info single chart object
         * @return {array of objects}   list of widgets returned
         */
        function getAnalyticsWidgets(printChart) {

            var widgets = [],
                done,
                promise = new Promise(function(resolve) {
                    done = resolve;
                }),
                index = 0,
                numCharts = printChart.charts.length;

            _.defer(next);

            return promise;

            function iteration(info, next) {

                widgets.push(_.assign({
                        type: PDF_CONST.TYPES.CHART,
                        title: printChart.name,
                        subTitle: info.name,
                        dateGeneratedOn: info.chartOptions.model.modelData.__generationDateString,
                        filters: _(info.filters).filter(
                            function(filter) {
                                return !filter.hidden && (_.indexOf(['date','duration'],filter.id) === -1);
                            }
                        ).map(
                            function(filter) {
                                var filterName = filter.text + ': ',
                                    filterValue = filter.selectedText,
                                    filterList = filter.options;

                                return pdfUtils.convertToPrintObject({
                                    key: filterName,
                                    value: filterValue,
                                    filterListLength: filterList ? filterList.length : null
                                }, {
                                    fontSize: 8,
                                    backgroundColor: '#e5e5e5'
                                });
                            }
                        ).value()
                    },
                    pdfUtils.extractChart(info)
                ));
                next();
            }

            function next() {
                if (index < numCharts) {
                    _.defer(iteration, printChart.charts[index], next);
                    index++;
                } else {
                    _.defer(done, widgets);
                }
            }
        }
    });
